import Select from "react-select";
import { SelectEditor } from "./selectEditor";

// Custom React Select Editor
export class DeploymentStatusSelectEditor extends SelectEditor {
  constructor(hotInstance) {
    super(hotInstance);

    this.objectName = null;
  }

  async prepare(row, col, prop, td, originalValue, cellProperties) {
    super.prepare(row, col, prop, td, originalValue, cellProperties);

    this.objectName = cellProperties.objectName;
  }

  async getOptionsFromUrl(url) {
    this.isLoading = true;

    const request = await fetch(url);
    const data = await request.json();
    const options = data.map((option) => ({
      value: option.id,
      label: option.name,
    }));
    this.options = options;

    this.isLoading = false;
  }

  renderComponent() {
    const selectedOption = this.options.find(
      (option) => option.value === this.originalValue?.id,
    );

    return (
      <Select
        options={this.options}
        value={selectedOption}
        onChange={this.handleChange}
        autoFocus
        menuIsOpen
        styles={this.getComponentStyles()}
        onBlur={this.close.bind(this)}
        onMenuClose={this.close.bind(this)}
        isClearable={true}
        isLoading={this.isLoading}
      />
    );
  }

  handleChange = (selectedOption) => {
    // Set the value
    this.value = {
      value: selectedOption?.value ?? "",
      label: selectedOption?.label ?? "",
    };

    // Update the cell value directly
    const { row, col } = this;

    if (this.hot) {
      this.hot.setDataAtCell(row, col, {
        id: this.value?.value ?? "",
        name: this.value?.label ?? "",
      });
    }

    this.close();
  };

  createColoredStyles(colorScheme) {
    const { height } = this.getEditedCellRect();

    return {
      control: (provided) => ({
        ...provided,
        minHeight: "initial",
        height: `${height}px`,
        borderRadius: 0,
        border: "none",
        boxShadow: "none",
        fontSize: "14px",
      }),
      menu: (provided) => ({
        ...provided,
        marginTop: 0,
        marginBottom: 0,
        fontSize: "14px",
      }),
      menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
        fontSize: "14px",
      }),
      option: (provided, state) => {
        const color = colorScheme?.[state.data.label];
        if (!color)
          return {
            ...provided,
            padding: "4px 8px",
            fontSize: "14px",
          };

        return {
          ...provided,
          padding: "4px 8px",
          fontSize: "14px",
          backgroundColor: state.isFocused ? `${color[0]}50` : color[0],
          color: state.isFocused ? "#000000" : color[1],
          ":active": {
            backgroundColor: color[0],
            color: color[1],
            fontSize: "14px",
          },
        };
      },
      valueContainer: (provided, state) => ({
        ...provided,
        padding: "0 8px",
        backgroundColor:
          colorScheme?.[state.getValue()?.[0]?.value]?.[0] ||
          provided.backgroundColor,
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        padding: 0,
      }),
      singleValue: (provided, state) => ({
        ...provided,
        fontSize: "14px",
        color: colorScheme?.[state.data.label]?.[1] || provided.color,
        backgroundColor:
          colorScheme?.[state.data.label]?.[0] || provided.backgroundColor,
      }),
    };
  }
}
